import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { CollectFundingClientsView } from '../components/views/collectFundingClientsView'

function CollectFundingClients() {
    return (
        <div className="collectFundingClients">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Collect Funding Clients'} />
                <CollectFundingClientsView />
            </MainView>
        </div>
    )
}

export default CollectFundingClients
